import { render, staticRenderFns } from "./work_flow_type_text.vue?vue&type=template&id=3305f843"
import script from "./work_flow_type_text.vue?vue&type=script&lang=js"
export * from "./work_flow_type_text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports